class Wishlist {
  constructor() {
    this.isWishlistPage = false
    this.storageKey = 'm-wishlist-products'
    this.products = []
    this.productNodes = {}

    this.pageTemplate = 'page.wishlist'
    this.addedClass = 'added-to-wishlist'
    this.hasItemClass = 'wishlist-has-item'
    this.selectors = {
      container: '.m-wishlist-page-content__wrapper',
      noProducts: '.m-wishlist-no-products',
      wrapper: '.m-wishlist-card',
      productCard: '.m-product-card',
      wishlistButton: '.m-wishlist-button',
      wishlistText: '.m-wishlist-button-text',
      removeButton: '.m-wishlist-remove-button',
      count: '.m-wishlist-count'
    }
    this.products = Array.from(new Set(Array.from(JSON.parse(localStorage.getItem(this.storageKey)) || [])))
    this.isWishlistPage = MinimogSettings.template === this.pageTemplate
    this.init()
  }

  init = async () => {
    if (this.isWishlistPage) {
      await this.renderWishlistPage()
      this.addEventToRemoveButtons()
    }
    this.setWishlistButtonsState()
    this.addEventToWishlistButtons()
    this.updateWishlistCount()
  }

  saveToStorage = () => {
    this.products = Array.from(new Set(this.products))
    localStorage.setItem(this.storageKey, JSON.stringify(this.products))
  }

  addToWishlist(handle) {
    if (handle && this.products.indexOf(handle) === -1) {
      this.products.push(handle)
      this.saveToStorage()
    }
  }

  removeFromWishlist(handle) {
    this.products = this.products.filter(hdl => hdl !== handle)
    this.saveToStorage()
  }

  setWishlistButtonsState = () => {
    const buttons = document.querySelectorAll(this.selectors.wishlistButton)
    buttons.forEach(btn => {
      const prodHandle = btn && btn.dataset.productHandle
      if (this.products.indexOf(prodHandle) >= 0 && btn && !btn.classList.contains(this.addedClass)) {
        this.toggleButtonState(btn, true)

        if (this.isWishlistPage) {
          btn.classList.remove(this.selectors.wishlistButton.replace('.', ''))
          btn.classList.add(this.selectors.removeButton.replace('.', ''))
        }
      }
    })
  }

  updateWishlistCount = () => {
    const size = this.products.length
    const pageCount = document.querySelector('#wishlist-item-count');
if (pageCount) {
 pageCount.innerHTML = `<span style="font-size:29px; font-weight:500; vertical-align:baseline;">${size}</span> Items in Your Wishlist`; 

}
    const countElems = document.querySelectorAll(this.selectors.count);
    [...countElems].forEach(elem => {
      elem.textContent = size
if (size < 1) {
  elem.textContent = '';
  elem.style.display = 'none';
} else {
  elem.textContent = size;
  elem.style.display = 'inline-flex';
}
    })
    const method = size ? 'add' : 'remove'
    document.body.classList[method](this.hasItemClass)
  }

  addEventToWishlistButtons = () => {
    addEventDelegate({
      selector: this.selectors.wishlistButton,
      handler: (e, btn) => {
        e.preventDefault()
        const productHandle = btn && btn.dataset.productHandle
        if (productHandle) {
          const active = !btn.classList.contains(this.addedClass)
          this.toggleButtonState(btn, active)
          this.updateWishlistCount()

          document.querySelectorAll(this.selectors.wishlistButton).forEach(btnItem => {
            if (btnItem && btnItem.dataset.productHandle === productHandle && btnItem !== btn) {
              const isAdded = !btnItem.classList.contains(this.addedClass)
              this.toggleButtonState(btnItem, isAdded)
            }
          })
        }
      }
    })
  }

  toggleButtonState = (btn, active) => {
    const productHandle = btn && btn.dataset.productHandle
    const wishlistText = btn && btn.querySelector(this.selectors.wishlistText)

    if (active) {
      this.addToWishlist(productHandle)
      btn.classList.add(this.addedClass)
    } else {
      this.removeFromWishlist(productHandle)
      btn.classList.remove(this.addedClass)
    }

    if (wishlistText) {
      const temp = wishlistText.dataset.revertText
      wishlistText.dataset.revertText = wishlistText.textContent
      wishlistText.textContent = temp
    }
  }

 
addEventToRemoveButtons = () => {
  addEventDelegate({
    selector: this.selectors.removeButton,
    handler: (e, btn) => {
      e.preventDefault();
      e.stopPropagation();

      const productHandle = btn.dataset.productHandle;
      if (!productHandle) return;

      const prod = btn.closest(this.selectors.wrapper);

      this.removeFromWishlist(productHandle);

      if (prod) prod.remove();

      this.updateWishlistCount();

      const remainingCards = document.querySelectorAll(
        `${this.selectors.container} ${this.selectors.wrapper}`
      );

      if (this.products.length === 0 || remainingCards.length === 0) {
        this.showNoProductsMessage();
      } else {
        this.showWishlistProducts();
      }
    }
  });
}


 wishlistRemoveButton(prdHandle) {
  const button = document.createElement("button");
  button.type = "button";
  button.classList.add("m-wishlist-remove-button", "pv-wishlist-remove-link");
  button.setAttribute("data-product-handle", prdHandle);

  button.innerHTML = `
    <svg width="16" height="16" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" stroke-width="1.8"
      stroke-linecap="round" stroke-linejoin="round"
      aria-hidden="true">
      <path d="M3 6h18"/>
      <path d="M8 6V4h8v2"/>
      <path d="M19 6l-1 14H6L5 6"/>
      <path d="M10 11v5M14 11v5"/>
    </svg>
    <span>Remove from Wishlist</span>
  `;

  return button;
}



  renderWishlistPage = async () => {
    const container = document.querySelector(this.selectors.container)
    if (container) {
      let noItemAvailable = true
      if (this.products.length) {
        const promises = this.products.map(async hdl => {
          const url = formatUrl('products', hdl, 'view=grid-card-item')
          const prodHTML = await fetchCache(url)
          console.log('Wishlist handle:', hdl)
console.log('Wishlist HTML:', prodHTML)
          const item = document.createElement("DIV");
          item.classList.add("m:hidden", "m:column", "m-wishlist-card");
          item.innerHTML = prodHTML
          if (item.querySelector(this.selectors.productCard)) {
            noItemAvailable = false
            item.appendChild(this.wishlistRemoveButton(hdl));
            this.productNodes[hdl] = item
          }
        })

        await Promise.all(promises)

        // Render in order
        this.products.forEach(hdl => {
          const prod = this.productNodes[hdl]
          if (prod) {
            container.appendChild(prod)

            if (MinimogTheme.CompareProduct) {
              MinimogTheme.CompareProduct.setCompareButtonsState();
            }

            prod.classList.remove('m:hidden');
          }
        })
      }

     if (noItemAvailable) {
  this.showNoProductsMessage();
} else {
  this.showWishlistProducts();
  this.setWishlistButtonsState();
}

      container.classList.add('is-visible')
      
const sortSelect = document.querySelector('#wishlist-sort');

if (sortSelect && !sortSelect.dataset.initialized) {
  sortSelect.dataset.initialized = 'true';

  sortSelect.addEventListener('change', () => {
    const cards = Array.from(container.children);
    const sortBy = sortSelect.value;

    const getName = (card) => {
      const title = card.querySelector(
        '.m-product-card__title, .m-product-card__name'
      );
      return (title?.textContent || card.textContent).trim().toLowerCase();
    };

    const getPrice = (card) => {
      const text = card.querySelector(
        '.m-price-item--regular, .m-price__regular, .m-price'
      )?.textContent || card.textContent;

      const match = text.match(/(?:₹|Rs\.?)\s*([\d,]+(?:\.\d{1,2})?)/i);
      return match ? Number(match[1].replace(/,/g, '')) : 0;
    };

    if (sortBy === 'name-asc') {
      cards.sort((a, b) => getName(a).localeCompare(getName(b)));
    } else if (sortBy === 'name-desc') {
      cards.sort((a, b) => getName(b).localeCompare(getName(a)));
    } else if (sortBy === 'price-asc') {
      cards.sort((a, b) => getPrice(a) - getPrice(b));
    } else if (sortBy === 'price-desc') {
      cards.sort((a, b) => getPrice(b) - getPrice(a));
    }

    cards.forEach(card => container.appendChild(card));
  });
}

    }
  }



showNoProductsMessage = () => {
  const container = document.querySelector(this.selectors.container);
  const noProducts = document.querySelector(this.selectors.noProducts);
  const toolbar = document.querySelector('.pv-wishlist-toolbar');

  if (container) {
    container.classList.add('m:hidden');
    container.classList.remove('is-visible');
  }

  if (noProducts) {
    noProducts.classList.remove('m:hidden');
    noProducts.style.display = 'block';
  }

  if (toolbar) toolbar.classList.add('pv-wishlist-empty');

  document.body.classList.remove(this.hasItemClass);
}
showWishlistProducts = () => {
  const container = document.querySelector(this.selectors.container);
  const noProducts = document.querySelector(this.selectors.noProducts);
  const toolbar = document.querySelector('.pv-wishlist-toolbar');

  if (container) {
    container.classList.remove('m:hidden');
    container.classList.add('is-visible');
  }

  if (noProducts) {
    noProducts.classList.add('m:hidden');
    noProducts.style.display = 'none';
  }

  if (toolbar) toolbar.classList.remove('pv-wishlist-empty');

  document.body.classList.add(this.hasItemClass);
}
}

MinimogTheme.Wishlist = new Wishlist()